
// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";               // ⬅️ import your Router component
import "./index.css";
import reportWebVitals from "./reportWebVitals";

let appVersion;
try {
  appVersion = require("../package.json");
  appVersion = appVersion && appVersion.version;
} catch (e) {
  console.error("Failed to load app version from package.json", e);
}

window.__DKVGLOBAL = {
  VERSION: `${appVersion}`,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);                      // ⬅️ render the Router

reportWebVitals();
